export default __webpack_public_path__ + "static/media/view.6d0d3bf8.png";